<template>
  <div>
    <!--查询条件控 货记录-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom"  size="mini" label-width="90px">
          <el-form-item label="一级货主:">
            <el-select v-model="searchFrom.oneCustomerTaxId" size="mini" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="searchFrom.twoCustomerTaxId" size="mini" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="增减类型:">
            <el-select v-model="searchFrom.virtualControlType" size="mini" placeholder="请选择">
              <el-option label="增项" value="1"></el-option>
              <el-option label="减项" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:">
            <div style="display: flex;">
            <el-date-picker v-model="searchFrom.startDate" size="mini" type="datetime" placeholder="选择创建时间"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="searchFrom.endDate" size="mini" placeholder="选择创建时间" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" @click="searchClick" size="mini" btnCode="00ZM0E0100" v-if="btnFlg[30]">查询
          </el-button>
          <el-button type="primary" @click="chongZhiClick" size="mini" btnCode="00ZM0E0200" v-if="btnFlg[31]">重置
          </el-button>
          <el-button type="primary" @click="exportClick" size="mini" btnCode="00ZM0E0300" v-if="btnFlg[32]">导出
          </el-button>
        </el-form-item>
        <el-form-item>
          <span>总重量：<span style="color:red">{{weightAll}}</span>&nbsp;&nbsp;吨</span>
          <span style="margin-left: 20px;">总件数：<span style="color:red">{{numberAll}}</span>&nbsp;&nbsp;件</span>
        </el-form-item>

      </el-form>
    </div>

    <!--  表格 v-loading='tabLoading'-->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%"
        style="width: 100%;" center :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row class="tableComent">
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="virtualControlNo" label="控货编号" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="virtualControlType" label="增减类型" align="center" width="80">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="oneCustomerName" label="一级货主" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="twoCustomerName" label="二级货主" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="goodTypeName" label="货物类型" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productionPlaceName" label="产地" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specificationName" label="规格" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="materialName" label="材质" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="virtualControlNumber" label="件数" align="center" width="70">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="virtualControlWeight" label="重量（吨）" align="center"
          width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="单号" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUserName" label="创建人" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tenantName" label="创建组织" align="center" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="dataSource" label="数据来源" align="center" width="180">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="[10, 20, 30, 40,50]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getRelationCustomer // 字典客户
} from '@/api/wms-stock.js'
import {
  getAllControlRecord // 列表
} from '@/api/common-signature.js'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'
import {
  emptyFn,
  formatterRowEmpty
} from '@/utils/util'
import DonMessage from '@/utils/message'

export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      weightAll: '0.000',
      numberAll: '0',
      btnIdArr: [
        '00ZP007B001',
        '00ZP007B002',
        '00ZP007B003',
        '00ZP007B004',
        '00ZP007B005',
        '00ZP007B006',
        '00ZP007B007',
        '00ZP007B008',
        '00ZP007B009',
        '00ZP007B00A',
        '00ZP007B00B',
        '00ZP007B00C',
        '00ZP007B00D',
        '00ZP007B00E',
        '00ZP007B00F',
        '00ZP007B00G',
        '00ZP007B00H',
        '00ZP007B00I',
        '00ZP007B00J',
        '00ZP007B00K',
        '00ZP007B00L',
        '00ZP007B00M',
        '00ZP007B00N',
        '00ZP007B00O',
        '00ZP007B00P',
        '00ZP007B00Q',
        '00ZP007B00R',
        '00ZP007B00S',
        '00ZP007B00T',
        '00ZP007B00U',
        '00ZM0E0100',
        '00ZM0E0200',
        '00ZM0E0300'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        instockDateStart: '',
        instockDateStartEnd: '',
        model: ''
      },

      pageNo: 1,
      pageSize: 20,
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      tableList: [],
      tabLoading: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/recordQuery')

    console.log(this.btnFlg[30], 'this.btnFlg')
    this.getSeatchData()
    this.getRelationCustomer()
    // this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.searchClick()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 205 + 'px'
  },
  methods: {
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
      }).catch(err => {
        this.$message.error(err.message)
      })
    },

    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getAllControlRecord({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.searchFrom
      })
        .then((res) => {
          console.log(res)
          this.tabLoading = false
          this.tableList = res.pageInfo.list
          this.total = res.pageInfo.total
          this.weightAll = res.total.totalWeight
          this.numberAll = res.total.totalNumber
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20
      }

      this.getSeatchData()
      // this.getVirtualBalingList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.pageSize = val
      this.getSeatchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageNo = val
      this.getSeatchData()
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.signature + '/sVirtualControlRecord/exportAllControlRecordExcel',
        this.searchFrom,
        '控货记录信息表'
      )
    }
  }
}

</script>
<style scoped lang='less'>
  .el-table {
    overflow: visible !important;
  }

  .searchBtnBox1 {
    display: flex;
    // margin-top: 10px;
    // margin-left: 10px;
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
